// @flow
import styled from 'styled-components';

export const Mask = styled.div`
    height: 100%;
    overflow: hidden;
`;

const pageNumbers = 3;
export const MainContainer = styled.div`
    align-items: flex-start;
    display: flex;
    height: 100%;
    transform: translate3d(${p => p.currentPage * -100 / pageNumbers}%, 0, 0);
    transition: transform 0.3s ease-out;
    width: ${pageNumbers * 100}%;
`;

export const PageContainer = styled.div`
    flex: 0 0 ${100 / pageNumbers}%;
    height: 100%;
    overflow: scroll;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-modal/style.js